import { AlertTriangle } from "lucide-react";
import { useTenant } from "@/hooks/useTenant";
import type { MaintenanceConfig } from "@/hooks/useMaintenance";

interface MaintenancePageProps {
  config: MaintenanceConfig;
}

export function MaintenancePage({ config }: MaintenancePageProps) {
  const tenant = useTenant();
  const eta = config.eta
    ? new Date(config.eta).toLocaleString(undefined, {
        dateStyle: "medium",
        timeStyle: "short",
      })
    : null;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center bg-background">
      <div className="max-w-md">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300">
          <AlertTriangle className="h-8 w-8" />
        </div>
        <h1 className="font-serif text-3xl font-semibold mb-3">
          {tenant.siteName} is under maintenance
        </h1>
        <p className="text-muted-foreground mb-6">{config.message}</p>
        {eta && (
          <p className="text-sm text-muted-foreground">
            Expected back:{" "}
            <span className="font-medium text-foreground">{eta}</span>
          </p>
        )}
      </div>
    </div>
  );
}
